"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.artifactType = 'internalRepaymentTape';
// Zod schema and new config type
exports.NodeConfigSchema = v4_1.z
    .object({
    rawRepaymentTapeArtifactSlug: v4_1.z
        .string()
        .describe('Slug for the raw repayment tape artifact'),
    generatedRepaymentTapeArtifactSlug: v4_1.z
        .string()
        .describe('Slug for the generated repayment tape artifact'),
    masterLoanTapeArtifactSlug: v4_1.z
        .string()
        .describe('Slug for the master loan tape artifact'),
})
    .describe('Configuration for internalRepaymentTape node');
// Zod schema and new node type
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    loanProductSlug: v4_1.z.string(),
    creditFacilitySlug: v4_1.z.string().nullable(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map